import { ReactNode } from 'react';
import styled from 'styled-components';

import { Horizontal, SBHorizontal, Vertical } from 'atoms/layout/flex';
import { LabelL, LabelM } from 'atoms/typography';

const Root = styled(SBHorizontal)`
  width: 100%;
  padding: var(--unit) var(--double-unit);
  position: relative;

  &:hover {
    &::after {
      content: '';
      position: absolute;
      inset: 0;
      height: 100%;
      z-index: -1;
      background: linear-gradient(
        to right,
        rgba(var(--c-rgb-onBase-success), 0.2) 0%,
        transparent calc(6 * var(--unit))
      );
      filter: blur(12px);
    }
  }
`;

type Props = {
  title: ReactNode;
  description: ReactNode;
  children: ReactNode;
};

export const NotificationPreferenceLayout = ({
  title,
  description,
  children,
}: Props) => {
  return (
    <Root>
      <Vertical gap={0}>
        <LabelL>{title}</LabelL>
        <LabelM color="var(--c-nd-600)">{description}</LabelM>
      </Vertical>
      <Horizontal>{children}</Horizontal>
    </Root>
  );
};
